/* At The Coalface header and mega menu */
(function () {
  function init(header) {
    if (header.dataset.atcReady) return;
    header.dataset.atcReady = '1';

    var root = document.documentElement;
    var nav = header.querySelector('[data-atc-nav]');
    var burger = header.querySelector('[data-atc-open]');
    var items = Array.prototype.slice.call(nav.querySelectorAll('.atc-item.has-panel'));
    var mobile = window.matchMedia('(max-width: 989px)');
    var canHover = window.matchMedia('(hover: hover)');
    var timer = null;
    nav.classList.add('atc-js');

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var top = item.querySelector('.atc-top');
      if (top) top.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closePanels(except) {
      items.forEach(function (i) { if (i !== except) setOpen(i, false); });
      if (!except) nav.classList.remove('atc-sub-open');
    }
    function openDrawer() {
      root.classList.add('atc-menu-open');
      burger.setAttribute('aria-expanded', 'true');
      var first = nav.querySelector('[data-atc-close]');
      if (first) first.focus({ preventScroll: true });
    }
    function closeDrawer(refocus) {
      if (!root.classList.contains('atc-menu-open')) return;
      root.classList.remove('atc-menu-open');
      burger.setAttribute('aria-expanded', 'false');
      closePanels();
      if (refocus) burger.focus();
    }

    /* Accordions: on mobile the first group in each menu is open, the rest closed. */
    function setupAccordions() {
      nav.querySelectorAll('[data-atc-panel]').forEach(function (panel) {
        panel.querySelectorAll('[data-atc-acc]').forEach(function (btn, idx) {
          if (mobile.matches) {
            btn.removeAttribute('tabindex');
            btn.setAttribute('aria-expanded', idx === 0 ? 'true' : 'false');
          } else {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }
    setupAccordions();
    var onChange = function () { closeDrawer(false); closePanels(); setupAccordions(); };
    if (mobile.addEventListener) mobile.addEventListener('change', onChange);
    else if (mobile.addListener) mobile.addListener(onChange);

    burger.addEventListener('click', openDrawer);

    header.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-atc-close]')) { closeDrawer(true); return; }

      var back = t.closest('[data-atc-back]');
      if (back) {
        var parent = back.closest('.atc-item');
        setOpen(parent, false);
        nav.classList.remove('atc-sub-open');
        parent.querySelector('.atc-top').focus();
        return;
      }

      var acc = t.closest('[data-atc-acc]');
      if (acc && mobile.matches) {
        acc.setAttribute('aria-expanded', acc.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
        return;
      }

      var top = t.closest('.atc-top');
      if (top) {
        var item = top.closest('.atc-item');
        if (!item.classList.contains('has-panel')) return;
        if (mobile.matches) {
          e.preventDefault();
          nav.scrollTop = 0;
          closePanels(item);
          setOpen(item, true);
          nav.classList.add('atc-sub-open');
          var b = item.querySelector('[data-atc-back]');
          if (b) b.focus({ preventScroll: true });
          nav.scrollLeft = 0;
        } else if (!canHover.matches && !item.classList.contains('is-open')) {
          /* Touch screens at desktop width: first tap opens, second tap follows the link. */
          e.preventDefault();
          closePanels(item);
          setOpen(item, true);
        }
      }
    });

    /* Desktop: open on hover (short delay so a diagonal mouse move does not flicker) and on keyboard focus. */
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (mobile.matches || !canHover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { closePanels(item); setOpen(item, true); }, 80);
      });
      item.addEventListener('mouseleave', function () {
        if (mobile.matches || !canHover.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, false); }, 160);
      });
      item.addEventListener('focusin', function () {
        if (mobile.matches) return;
        clearTimeout(timer);
        closePanels(item);
        setOpen(item, true);
      });
      item.addEventListener('focusout', function (e) {
        if (mobile.matches) return;
        if (!item.contains(e.relatedTarget)) setOpen(item, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (mobile.matches) { closeDrawer(true); return; }
      var open = nav.querySelector('.atc-item.is-open');
      if (open) { setOpen(open, false); open.querySelector('.atc-top').focus(); setOpen(open, false); }
    });
    document.addEventListener('click', function (e) {
      if (!mobile.matches && !header.contains(e.target)) closePanels();
    });
  }

  /* "Open today 8:30am - 5:30pm" in the top strip, worked out in the store's time zone. */
  function hours() {
    document.querySelectorAll('[data-atc-hours]').forEach(function (el) {
      var out = el.querySelector('[data-atc-today]');
      if (!out) return;
      try {
        var map = JSON.parse(el.getAttribute('data-atc-hours'));
        var day = new Intl.DateTimeFormat('en-AU', { weekday: 'short', timeZone: el.getAttribute('data-atc-tz') || 'Australia/Sydney' }).format(new Date()).slice(0, 3);
        var h = map[day];
        out.textContent = h ? 'Open today ' + h : 'Closed today';
      } catch (err) { out.textContent = ''; }
    });
  }

  function boot() {
    document.querySelectorAll('[data-atc-header]').forEach(init);
    hours();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();